import {Select} from 'antd';
import React from 'react';
import {injectIntl} from 'react-intl';
import Constants from '../../../services/Constants';
import FieldError from "../input/FieldError";


class ServiceCategorySelector extends React.Component {

  render() {
    const {intl: {formatMessage}, className, error, service, ...attributes} = this.props;

    const errorClassName = error ? " error" : '';

    const isTireOnly = attributes.value === Constants.TIRE_SERVICE.value || ['C01', 'C02'].includes(service);
    const categories = isTireOnly ? [Constants.TIRE_SERVICE] : [Constants.BODYWORK_SERVICE, Constants.MAINTENANCE_AND_REPAIR_SERVICE];

    const options = categories.map(category =>
      <Select.Option value={category.value} key={category.value}>
        {formatMessage(category.label)}
      </Select.Option>
    );

    return (
      <span className={className + errorClassName}>
        <Select placeholder={formatMessage({id: 'placeholder.service-category'})} {...attributes}>
          {options}
        </Select>
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    )
  }
}

export default injectIntl(ServiceCategorySelector);
